module.exports = __webpack_public_path__ + "img/DevSecOps Best Practices by Micro Beaver for IT Solutions.05606395.svg";